(async () => {

  if(!customElements.get('collection-products')) {

    class CollectionProducts extends HTMLElement {
      constructor() {
        super();

        this.currentPage = this.querySelector('[data-current-page]');
        this.currentPageValue = parseInt(this.currentPage.value);
        this.totalPages = this.querySelector('[data-total-pages]');
        this.totalPagesValue = parseInt(this.totalPages.value);

        this.previousPageIndex = this.currentPageValue;
        this.nextPageIndex = this.currentPageValue;

        this.loadMoreWrapper = document.querySelector('#main-collection');
        this.sectionUsedForDataFetch = 'collection-filters';
        this.wrapperID = '#products';
        this.wrapperIDSelector = '[data-collection-product-grid]';

        this.init();
      }

      /**
       * init
       */
      init() {

        this.loadButtons = this.querySelectorAll('[data-collection-load-more]');

        // Add click events to the load buttons
        this.loadButtons.forEach(button => {
          button.addEventListener('click', event => {
            this.isLoading();
            this.handleLoadMoreProducts(event);
          })
        });

      }

      handleLoadMoreProducts(event) {
        // Refresh data again
        this.currentPageValue = parseInt(this.currentPage.value);
        this.totalPagesValue = parseInt(this.totalPages.value);

        if(event.currentTarget.dataset.collectionLoadMore == 'next') {
          this.nextPageIndex += 1;
        } else {
          this.previousPageIndex -= 1;
        }

        const pageToFetch = event.currentTarget.dataset.collectionLoadMore == 'next' ? this.nextPageIndex : this.previousPageIndex;
        const currentUrl = new URL(window.location.href);
        let searchUrl = currentUrl.search;

        let urlParams = new URLSearchParams(currentUrl.search);

        urlParams.set('page', pageToFetch);

        // Check if collection view is alt or normal
        if( searchUrl.includes('view=alt')) {
          urlParams.set('view', 'alt');
        }

        const searchParams = urlParams.toString(event.currentTarget.dataset.collectionLoadMore == 'next' ? this.nextPageIndex : this.previousPageIndex );

        const url = `${window.location.pathname}?section_id=${this.sectionUsedForDataFetch}&${searchParams}`;
        this.renderProductsFromFetch(url, searchParams, event.currentTarget.dataset.collectionLoadMore, pageToFetch);
      }

      /**
       * renderProductsFromFetch
       * @description Renders the products based on the fetch url data.
       * @param {String} url
       * @param {String} searchParams
       * @param {String} direction
       * @param {String} pageToFetch
      */
      async renderProductsFromFetch(url, searchParams, direction, pageToFetch) {

        try {

          // Get the data we need
          const response = await fetch(url);

          // Check response
          if(response.status != 200) {
            throw response;
          }

          // Get the text data
          const responseText = await response.text();

          // String to DOM
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          // Check response ID
          if (html.querySelector(`${this.wrapperID}`)) {

            // Update the wrapper with the new products
            const newContent = html.querySelector(`${this.wrapperID} ${this.wrapperIDSelector}`).innerHTML;

            // Depending on the direction of the load more click, insert the result before or after
            if (direction == 'next') {
              this.loadMoreWrapper.querySelector(`${this.wrapperIDSelector}`).insertAdjacentHTML('beforeend', newContent);
            } else {
              this.loadMoreWrapper.querySelector(`${this.wrapperIDSelector}`).insertAdjacentHTML('afterbegin', newContent);
            }

            // Update the hidden input and saved value with the new value
            this.currentPage.value = pageToFetch;
            this.currentPageValue = pageToFetch;

            if(pageToFetch == this.totalPagesValue) {
              this.querySelector('[data-collection-load-more="next"]').classList.add('hidden');
              this.querySelector('[data-collection-load-more="next"]').parentElement.classList.add('hidden');
            }

            if(pageToFetch == 1) {
              this.querySelector('[data-collection-load-more="previous"]').classList.add('hidden');
              this.querySelector('[data-collection-load-more="previous"]').parentElement.classList.add('hidden');
            }

          }

          history.pushState('','', `?${searchParams}`);

          this.isLoading(false);

        } catch (error) {
          console.log(error);
          this.isLoading(false);
        }
      }

      /**
       * updateURLHash
       * @param {String} url
      */
      updateURLHash(url) {
        history.pushState('', '', url);
      }

      /**
       * isLoading
       * @description
       * @param {Boolean} state
       */
      isLoading(state = true) {
        this.loadButtons.forEach(button => {
          button.disabled = state;
          state ? button.classList.add('loading') : button.classList.remove('loading');
        });
      }

    }

    customElements.define('collection-products', CollectionProducts);

  }

})();
